import React, {useEffect, useState} from 'react';

import {AudioOutputTestButton} from '@pexip/media-components';

import {TestId} from '../../test/testIds';

import {PlaySound} from './PlaySound.viewModel';

export const OutputAudioTester: React.FC<{
    sinkId: string;
    isDisabled?: boolean;
}> = ({sinkId, isDisabled}) => {
    const [shouldPlay, setShouldPlay] = useState(false);

    useEffect(() => {
        if (isDisabled) {
            setShouldPlay(false);
        }
    }, [isDisabled]);

    const handleClick = () => {
        setShouldPlay(prev => !prev);
    };

    return (
        <>
            <PlaySound
                data-testid={TestId.AudioTestOutput}
                loop
                play={shouldPlay}
                controls={false}
                preload="auto"
                sinkId={sinkId}
                sound="test"
            />
            <AudioOutputTestButton
                onClick={handleClick}
                shouldPlay={shouldPlay}
                isDisabled={isDisabled}
            />
        </>
    );
};
